<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditExpenseModal"
        persistent
        max-width="700px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  {{ isUpdate ? 'Update Expense' : 'Add New Expense' }}
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  &nbsp;X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                {{ isUpdate ? 'Updated successfully' : 'Added successfully' }}
              </v-alert>

              <v-alert
                type="error"
                :value="errorAlert"
              >
                There is an error
              </v-alert>
              <v-layout wrap>

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <branch-select v-model="formData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="expenseTypesList"
                    v-model="formData.expense_type_id_fk"
                    :error-messages="errors.collect('Expense Type')"
                    data-vv-name="Expense Type"
                    label="Expense Type *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="suppliersList"
                    v-model="formData.supplier_id_fk"
                    :error-messages="errors.collect('Supplier')"
                    data-vv-name="Supplier"
                    label="Supplier *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="banksList"
                    v-model="formData.bank_id_fk"
                    :error-messages="errors.collect('Bank')"
                    data-vv-name="Bank"
                    label="Bank *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Supplier Invoice Number"
                    v-model="formData.supplier_invoice_number"
                    :error-messages="errors.collect('Supplier Invoice Number')"
                    data-vv-name="Supplier Invoice Number"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Amount *"
                    v-model="formData.amount"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required'"
                    data-vv-name="Amount"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="expenseStatusList"
                    v-model="formData.status"
                    :error-messages="errors.collect('Status')"
                    data-vv-name="Status"
                    label="Status *"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <label class="d-block mb-1">Expense Date</label>
                  <input
                    type="date"
                    v-model="formData.expense_date"
                    class="base-date-picker"
                  >
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    label="Note"
                    v-model="formData.note"
                    :error-messages="errors.collect('Note')"
                    data-vv-name="Note"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: [
    'addEditExpenseModal',
    'formData',
    'isUpdate',
    'expenseTypesList',
    'suppliersList',
    'banksList',
  ],

  data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
      expenseStatusList: [
        { text: 'Paid', value: 'paid' },
        { text: 'Unpaid', value: 'unpaid' },
        { text: 'Cash', value: 'cash' }
      ]
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/expenses/${this.formData.expense_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token },
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          } else {
            Axios.post('api/expenses', this.formData, {
              headers: { Authorization: 'Bearer ' + token },
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          }
        }
      })
    },
  },
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/expense/addEdit.vue